import { render, staticRenderFns } from "./AcademicPerformance.vue?vue&type=template&id=4d1f78e8&scoped=true"
import script from "./AcademicPerformance.vue?vue&type=script&lang=js"
export * from "./AcademicPerformance.vue?vue&type=script&lang=js"
import style0 from "./AcademicPerformance.vue?vue&type=style&index=0&id=4d1f78e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f78e8",
  null
  
)

export default component.exports